import { Headers, RequestOptions } from "@angular/http";
import { LoadingController, ToastController } from "ionic-angular";
import { Injectable } from "@angular/core";
// import { Storage } from '@ionic/storage';

@Injectable()
export class ServiceProvider {
  version: any = "v1";
  ApiURL: any =
    "https://theplaza-v2.ingenious-simulation.com/" + this.version + "/";
  URLAuthen = "https://theplaza-v2.ingenious-simulation.com/oauth2/token";
  URLVideo = this.ApiURL + "videos";

  URLThemeSetting =
    this.ApiURL +
    "translations?token=02ab88616c5bbdd5bbcbe82ca0a300e917570d3e&language=";
  URLSync = this.ApiURL + "users/sync-platform";

  URLGameState = this.ApiURL + "games/state";

  URLLanguage = this.ApiURL + "languages";
  URLPlazaList = this.ApiURL + "plazas";
  URLCheckStep = this.ApiURL + "games/state";
  URLUserInfo = this.ApiURL + "users/info";
  URLPlazaTeams = this.ApiURL + "plazas/teams";
  URLQuiz = this.ApiURL + "questions";
  URLUserStatEnd = this.ApiURL + "users/state/end";
  URLPlazaBudget = this.ApiURL + "plazas/budget";
  URLPlazaSpace = this.ApiURL + "plazas/space";
  URLShops = this.ApiURL + "shops";
  URLShopsSocial = this.ApiURL + "shops/socials";
  URLTheme = this.ApiURL + "themes";
  URLGetTheme = this.ApiURL + "plazas/themes";
  URLThemeSave = this.ApiURL + "plazas/themes";
  URLDiscount = this.ApiURL + "discounts";
  URLSpaces = this.ApiURL + "plazas/spaces";
  URLPostSocial = this.ApiURL + "plazas/social";
  URLUpdateSocial = this.ApiURL + "plazas/social/";
  URLTicketRemove = this.ApiURL + "plazas/social/";
  URLPlazaStatBudgets = this.ApiURL + "plazas/stats/budgets";
  URLPlazaMissions = this.ApiURL + "plazas/missions";
  URLPlazaStatProfit = this.ApiURL + "plazas/stats/profit_and_loss";
  URLPlazaStatCashflow = this.ApiURL + "plazas/stats/cash_flow_statement";
  URLPlazaStatMerchant = this.ApiURL + "plazas/stats/total_sales_by_merchant";
  URLPlazaStatShopper = this.ApiURL + "plazas/stats/total_shopper";
  URLPlazaLatestMovement = this.ApiURL + "plazas/latest_movements";
  URLPlazaShopperTraffic = this.ApiURL + "plazas/stats/shopper_traffic";
  URLPlazaShopperAccumulate = this.ApiURL + "plazas/stats/accumulate_shopper";
  URLPlazaSalesAccumulate = this.ApiURL + "plazas/stats/accumulate_sales";
  URLPlazaRentSpaceCode = this.ApiURL + "plazas/rent/space/code";
  URLPlazaDiscountCode = this.ApiURL + "plazas/discount/code";

  URLMerchantList = this.ApiURL + "merchants";
  URLMerchantTeams = this.ApiURL + "merchants/teams";
  URLMerchantSpace = this.ApiURL + "merchants/spaces";
  URLMerchantBudget = this.ApiURL + "merchants/budget";
  URLMerchantShop = this.ApiURL + "merchants/shops";
  URLMerchantStatBudgets = this.ApiURL + "merchants/stats/budgets";
  URLMerchantMissions = this.ApiURL + "merchants/missions";
  URLMerchantLatestMovement = this.ApiURL + "merchants/latest_movements";
  URLMerchantStatUnit = this.ApiURL + "merchants/stats/total_unit_sold";
  URLMerchantStatUnitSold = this.ApiURL + "merchants/stats/total_unit_sold/";
  URLMerchantProfit = this.ApiURL + "merchants/stats/profit_and_loss";
  URLMerchantCashFlow = this.ApiURL + "merchants/stats/cash_flow_statement";
  URLMerchantRevenue = this.ApiURL + "merchants/stats/total_revenue";
  URLMerchantShopperType = this.ApiURL + "merchants/stats/shopper_type";
  URLMerchantStockStatus = this.ApiURL + "merchants/stats/stock_status";
  URLMerchantRentSpace = this.ApiURL + "merchants/rent/space";
  URLMerchantRentSpaceConfirm = this.ApiURL + "merchants/rent/space/confirm";
  URLMerchantDiscountCode = this.ApiURL + "merchants/discount/code";

  URLShopperList = this.ApiURL + "shoppers";
  URLShopperTeam = this.ApiURL + "shoppers/teams";
  URLShopperBudget = this.ApiURL + "shoppers/budget";
  URLShopperMissions = this.ApiURL + "shoppers/missions";
  URLShopperShop = this.ApiURL + "shoppers/plazas/";
  URLShopperBag = this.ApiURL + "shoppers/carts";
  URLShopperStatBudgets = this.ApiURL + "shoppers/stats/budgets";
  URLShopperShopping = this.ApiURL + "shoppers/shoppings";
  URLShopperStatItems = this.ApiURL + "shoppers/stats/item_lists";
  URLShopperStatPurchased = this.ApiURL + "shoppers/stats/item_purchased";
  URLShopperStatHappiness = this.ApiURL + "shoppers/stats/happiness_points";
  URLShopperLatestMovement = this.ApiURL + "shoppers/latest_movements";
  URLShopperVote = this.ApiURL + "shoppers/vote/merchant";
  URLShopperMissionsCode = this.ApiURL + "shoppers/missions/code";
  URLShopperMissionsJoin = this.ApiURL + "shoppers/missions/join";
  URLShopperBuyShop = this.ApiURL + "shoppers/buy/shop";
  URLShopperBuyShopConfirm = this.ApiURL + "shoppers/buy/shop/confirm";
  URLShopperBuySocial = this.ApiURL + "shoppers/buy/social";
  URLShopperBuySocialConfirm = this.ApiURL + "shoppers/buy/social/confirm";

  constructor(
    // private storage: Storage,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController
  ) {}

  getHeader() {
    var headers = new Headers();
    headers.append("Accept", "application/json");
    const requestOptions = new RequestOptions({ headers: headers });
    return requestOptions;
  }

  getHeaderAuthen() {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    const requestOptions = new RequestOptions({ headers: headers });
    return requestOptions;
  }

  presentLoading(time = 1000) {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
      duration: time,
    });
    loader.present();
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 5000,
      showCloseButton: false,
      closeButtonText: "x",
      dismissOnPageChange: true,
      position: "top",
    });
    toast.present();
  }

  presentToastInternet() {
    let toast = this.toastCtrl.create({
      message: "Check connect your internet.",
      duration: 5000,
      showCloseButton: true,
      closeButtonText: "x",
      dismissOnPageChange: false,
      position: "top",
    });
    toast.present();
  }

  currencyFormat(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}



// WEBPACK FOOTER //
// ./src/providers/service/service.ts